<template>
  <span ref="upload-button" v-show="support">
    <slot></slot>
  </span>
</template>

<script>
import {uploaderMixin, supportMixin} from './tools/mixins';

export default {
    name: 'uploader-btn',
    mixins: [uploaderMixin, supportMixin],
    props: {
        directory: {
            type: Boolean,
            default: false
        },
        single: {
            type: Boolean,
            default: false
        },
        attrs: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    mounted () {
        this.$nextTick(() => {
            this.uploader.assignBrowse(
                this.$refs['upload-button'],
                this.directory,
                this.single,
                this.attrs
            );
        });
    }
};
</script>
